import { useId } from 'react';
import { useController } from 'react-hook-form';

interface UseInputComboboxControllerOptions {
  defaultValue: unknown;
  deps?: string | string[];
  disabled?: boolean;
  name: string;
  required?: boolean | string;
}

/** Connects a combobox to React Hook Form and derives its validation state. */
export function useInputComboboxController({
  defaultValue,
  deps,
  disabled: disabledProp,
  name,
  required,
}: UseInputComboboxControllerOptions) {
  const { field, fieldState } = useController({
    name,
    defaultValue,
    rules: { required, deps },
  });
  const disabled = field.disabled || disabledProp;
  const inputId = useId();

  return {
    disabled,
    error: disabled ? null : fieldState.error,
    errorId: `${inputId}-error`,
    field,
    inputId,
  };
}
